import ManagementDashboardShell from "./dashboard/ManagementDashboardShell";

const SLNManagementPage = () => <ManagementDashboardShell />;

export default SLNManagementPage;
